// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5861":"d9412b49","7553":"d9412b49","9579":"6fb83aaa","9926":"0691d9b7"}[chunkId] + ".chunk.css";
};